(function () {
    const STORAGE_KEY = "utm_contact_tags";
    const SHADOW_HOST_SELECTOR =
      "#pop-convert-app";
  
    const FIELD_LABELS = {
      utm_source: {
        label: "UTM Source",
        storageField: "source"
      },
      utm_medium: {
        label: "UTM Medium",
        storageField: "medium"
      },
      utm_campaign: {
        label: "UTM Campaign",
        storageField: "campaign"
      }
    };
  
    const populatedInputs = new WeakMap();
  
    function normalizeLabel(value) {
      return String(value || "")
        .replace(/\s+/g, " ")
        .trim()
        .toLowerCase();
    }
  
    function readStoredUtm() {
      const rawValue =
        localStorage.getItem(STORAGE_KEY);
  
      if (!rawValue) {
        return null;
      }
  
      try {
        return JSON.parse(rawValue);
      } catch (error) {
        console.error(
          "[Pop Convert UTM] localStorage 解析失败",
          error
        );
  
        return null;
      }
    }
  
    function getShadowRoot() {
      const host = document.querySelector(
        SHADOW_HOST_SELECTOR
      );
  
      return host?.shadowRoot || null;
    }
  
    function matchFieldConfig(text) {
      const normalized = normalizeLabel(text);

      return (
        Object.entries(FIELD_LABELS).find(
          function (entry) {
            return (
              normalizeLabel(entry[1].label) ===
              normalized
            );
          }
        ) || null
      );
    }

    function findMappedFields(shadowRoot) {
      const fieldsByInput = new Map();

      function addField(
        standardField,
        config,
        container,
        input
      ) {
        if (!input || fieldsByInput.has(input)) {
          return;
        }

        fieldsByInput.set(input, {
          standardField,
          storageField: config.storageField,
          container,
          input
        });
      }

      Array.from(
        shadowRoot.querySelectorAll("label")
      ).forEach(function (labelElement) {
        const matchedEntry = matchFieldConfig(
          labelElement.textContent
        );

        if (!matchedEntry) {
          return;
        }

        const container =
          labelElement.parentElement;
        const input = container?.querySelector(
          "input, textarea, select"
        );

        if (!input) {
          return;
        }

        addField(
          matchedEntry[0],
          matchedEntry[1],
          container,
          input
        );
      });

      Array.from(
        shadowRoot.querySelectorAll(
          "input[placeholder], textarea[placeholder]"
        )
      ).forEach(function (input) {
        if (fieldsByInput.has(input)) {
          return;
        }

        const matchedEntry = matchFieldConfig(
          input.getAttribute("placeholder")
        );

        if (!matchedEntry) {
          return;
        }

        const container =
          input.closest(".bar-input-form") ||
          input.parentElement;

        addField(
          matchedEntry[0],
          matchedEntry[1],
          container,
          input
        );
      });

      return Array.from(fieldsByInput.values());
    }

    function hideUtmField(field) {
      if (!field.container) {
        return;
      }

      field.container.setAttribute(
        "data-utm-hidden",
        "true"
      );

      const hideTarget =
        field.container.parentElement ||
        field.container;

      if (hideTarget.style.display === "none") {
        return;
      }

      hideTarget.style.display = "none";
    }
  
    function setNativeValue(element, value) {
      let prototype;
  
      if (element instanceof HTMLTextAreaElement) {
        prototype = HTMLTextAreaElement.prototype;
      } else if (element instanceof HTMLSelectElement) {
        prototype = HTMLSelectElement.prototype;
      } else {
        prototype = HTMLInputElement.prototype;
      }
  
      const descriptor =
        Object.getOwnPropertyDescriptor(
          prototype,
          "value"
        );
  
      if (descriptor?.set) {
        descriptor.set.call(element, value);
      } else {
        element.value = value;
      }
    }
  
    function notifyVue(element, value) {
      const stringValue = String(value || "");
  
      if (!stringValue) {
        return;
      }
  
      if (
        populatedInputs.get(element) === stringValue &&
        element.value === stringValue
      ) {
        return;
      }
  
      setNativeValue(element, stringValue);
  
      try {
        element.dispatchEvent(
          new InputEvent("input", {
            bubbles: true,
            composed: true,
            inputType: "insertText",
            data: stringValue
          })
        );
      } catch (error) {
        element.dispatchEvent(
          new Event("input", {
            bubbles: true,
            composed: true
          })
        );
      }
  
      element.dispatchEvent(
        new Event("change", {
          bubbles: true,
          composed: true
        })
      );
  
      element.dispatchEvent(
        new FocusEvent("blur", {
          bubbles: true,
          composed: true
        })
      );
  
      populatedInputs.set(element, stringValue);
    }
  
    function populateFields(shadowRoot) {
      const fields = findMappedFields(shadowRoot);
      const storedUtm = readStoredUtm();

      fields.forEach(function (field) {
        hideUtmField(field);

        if (!storedUtm) {
          return;
        }

        const value =
          storedUtm[field.storageField];

        if (!value) {
          return;
        }

        notifyVue(field.input, value);

        field.input.setAttribute(
          "data-utm-field",
          field.standardField
        );

        console.info(
          "[Pop Convert UTM] 已填充字段",
          field.standardField,
          value
        );
      });
    }
  
    function initializeShadowRoot(shadowRoot) {
      populateFields(shadowRoot);
  
      /*
       * document 上的 MutationObserver 观察不到
       * Shadow Root 内部的变动，因此必须直接观察 shadowRoot。
       */
      const observer = new MutationObserver(function () {
        populateFields(shadowRoot);
      });
  
      observer.observe(shadowRoot, {
        childList: true,
        subtree: true
      });
    }
  
    function waitForShadowRoot() {
      const shadowRoot = getShadowRoot();
  
      if (shadowRoot) {
        initializeShadowRoot(shadowRoot);
        return;
      }
  
      const documentObserver =
        new MutationObserver(function () {
          const root = getShadowRoot();
  
          if (!root) {
            return;
          }
  
          documentObserver.disconnect();
          initializeShadowRoot(root);
        });
  
      documentObserver.observe(
        document.documentElement,
        {
          childList: true,
          subtree: true
        }
      );
    }
  
    waitForShadowRoot();
  })();